import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../styles/tips.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";

const Tips = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initAppBrowser(["messages"]));
    window.scrollTo(0, 0);
  }, []);

  const imgPrefix = "https://cdn.cardcash.com/website/drip/";

  return (
    <div className="mar-t-125">
      <div>
        <Helmet
          title={"Save more with savvy saving tips"}
          meta={[
            {
              name: "description",
              content:
                "Learn how to be a better saver. Savings tips for the savviest savers from CardCash, the world's largest gift card exchange."
            }
          ]}
        />
        <div className="tips-header">
          <div>
            <h1>Savvy Savings Tips</h1>
            <h1>Great ways to maximize your savings</h1>
          </div>
          <img className="lightbulb" src={`${imgPrefix}lightbulb.png`} alt="" />
        </div>

        <div className="stack">
          <div>
            <h2
              style={{
                marginBottom: "5px",
                fontWeight: "300",
                fontSize: "26px"
              }}
            >
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>1</span>{" "}
              Stack deals
            </h2>
            <p>
              That handbag you’ve been dying to buy just went on sale. Sales are
              for everyone, savvy savers stack gift cards on top of sales for
              super savvy savings. This is a great way to save with CardCash
            </p>
          </div>
          <img src={`${imgPrefix}stack-deals.png`} alt="" />
        </div>

        <div className="own-sale">
          <img src={`${imgPrefix}ipad.png`} alt="" />
          <div>
            <h2
              style={{
                fontWeight: "300",
                fontSize: "26px",
                marginBottom: "0px"
              }}
            >
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>2</span>{" "}
              Make your own sale
            </h2>
            <p>
              A quick search will net you the best savings!
              <br className="hidden-md" />
              More than one store may carry the product you need,
              <br className="hidden-md" />
              search over 1200 brands for the highest discounts.
            </p>
          </div>
        </div>

        <div className="save-everyday">
          <div>
            <h2>
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>3</span>{" "}
              Save on everyday items
            </h2>
            <p>
              Even small discounts on items you buy regularly such as
              toiletries, groceries, and gas can really add up over time. Don’t
              forget to save on your everyday shopping.
            </p>
          </div>

          <img
            style={{
              height: "450px",
              marginBottom: "206px",
              marginLeft: "30px"
            }}
            src={`${imgPrefix}save-on-everyday-items.png`}
            alt=""
          />
        </div>

        <div className="online-shopping">
          <img src={`${imgPrefix}online-shopping.png`} />
          <div>
            <h2>
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>4</span>{" "}
              Start with the discount, work your way back{" "}
            </h2>
            <p>
              Instead of looking for discounts only after you find something you
              want to buy, start looking for the stores that have the best
              discounts and then search those stores for products you want to
              buy.
            </p>
            <p>
              Use the “Highest Discount” filter on the CardCash buy page to find
              the best discounts.
            </p>
          </div>
        </div>

        <div className="great-deal-sites">
          <div>
            <h2>
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>5</span>{" "}
              Sites to find great deals
            </h2>
            <p>
              Sites like Slickdeals, Brads Deals, Dans Deals, and Deal News can
              help you find great deals. Once you’ve found one, use CardCash
              gift cards to add to your savings.
            </p>
          </div>
          <img src={`${imgPrefix}sale-site.png`} alt="" />
        </div>

        <div className="spoil-yourself">
          <img src={`${imgPrefix}spoil-yourself.png`} alt="" />
          <div>
            <h2>
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>6</span>{" "}
              Spoil Yourself
            </h2>
            <p>
              Instead of saving, you can use discounted gift cards to stretch
              your dollars further. Planning to go out to dinner? With
              discounted gift cards you can spend the same amount for dinner and
              a movie, and still have change left over for popcorn.
            </p>
          </div>
        </div>

        <div className="unwanted-cards">
          <div>
            <h2>
              <span style={{ fontSize: "40px", fontWeight: "normal" }}>7</span>{" "}
              Turn unwanted gift cards into cash
            </h2>
            <p>
              Do you have gift cards you never plan on using? Sell them for cash
              or trade them for cards you DO want.
            </p>
          </div>
          <img src={`${imgPrefix}coins.png`} alt="" />
        </div>

        <div className="refer-friends">
          <img src={`${imgPrefix}refer-friend.png`} alt="" />
          <div>
            <h2>
              <span>8</span> Refer your friends
            </h2>
            <p>
              Your friends deserve to save too, don't they? You'll earn $5 for
              every friend you refer, and they'll get $5 as well. It's a savings
              win win!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tips;
